export default __webpack_public_path__ + "static/media/logoethfan.78e1dd45.png";